import React from 'react';
import { createStackNavigator } from '@react-navigation/stack';
import {
  EDIT_ORDER_GUIDE_ROUTES,
  ORDER_GUIDE_ROUTES,
} from '@/navigators/routes';
import { EditOrderGuideAddPartitionItemsScreen } from '@/screens/partners/edit-order-guide-add-partition-items-screen';
import { EditOrderGuideContextProvider } from '@/contexts/edit-order-guide-context';
import { EditOrderGuideScreen } from '@/screens/partners/edit-order-guide-screen';
import {
  EditOrderGuideStackParams,
  OrderGuideStackParams,
} from '@/navigators/types';
import { RouteProp } from '@react-navigation/native';
import { useModalStackScreenOptions } from '@/hooks/use-modal-stack-screen-options';

const Stack = createStackNavigator<EditOrderGuideStackParams>();

interface Props {
  route: RouteProp<OrderGuideStackParams, ORDER_GUIDE_ROUTES.Edit>;
}

export const EditOrderGuideStack: React.FC<Props> = ({ route }) => {
  const modalScreenOptions = useModalStackScreenOptions();
  return (
    <EditOrderGuideContextProvider>
      <Stack.Navigator
        initialRouteName={EDIT_ORDER_GUIDE_ROUTES.Base}
        screenOptions={modalScreenOptions}
      >
        <Stack.Screen
          component={EditOrderGuideScreen}
          initialParams={route.params}
          name={EDIT_ORDER_GUIDE_ROUTES.Base}
        />
        <Stack.Screen
          component={EditOrderGuideAddPartitionItemsScreen}
          name={EDIT_ORDER_GUIDE_ROUTES.AddPartitionItems}
        />
      </Stack.Navigator>
    </EditOrderGuideContextProvider>
  );
};
